import React, { FC } from 'react';
import { Button, Flex } from 'portal-commons';
import Divider from './Divider';

interface StepFooterProps {
  onBack?: () => void;
  nextLabel?: string;
  nextDisabled?: boolean;
  hideDivider?: boolean;
}

const StepFooter: FC<StepFooterProps> = ({
  onBack,
  nextLabel = 'Next',
  nextDisabled = false,
  hideDivider,
  children,
}) => {
  return (
    <Flex sx={{ flexDirection: 'column', width: '100%', mt: 'auto' }}>
      {!hideDivider && <Divider sx={{ mx: 24 }} />}
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 16,
          px: 24,
          py: 20,
        }}
      >
        <Flex sx={{ flex: 1, mr: 24 }}>{children}</Flex>

        <Flex sx={{ gap: 16, flexShrink: 0 }}>
          {onBack && (
            <Button
              data-testid="cspVerificationFormPreviousButton"
              onClick={onBack}
              variant="outline"
              shape="square"
            >
              Previous
            </Button>
          )}
          <Button
            data-testid="cspVerificationFormNextButton"
            type="submit"
            shape="square"
            disabled={nextDisabled}
            style={{ minWidth: 160 }}
          >
            {nextLabel}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default StepFooter;
